import { render, staticRenderFns } from "./UserContentModal.vue?vue&type=template&id=7643f436&"
import script from "./UserContentModal.vue?vue&type=script&lang=js&"
export * from "./UserContentModal.vue?vue&type=script&lang=js&"
import style0 from "./UserContentModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports